module.exports = __webpack_public_path__ + "static/media/waleed.97d7297f.png";